/**
 * Determines given email's validity.
 * See https://ui.dev/validate-email-address-javascript/
 * @param email {string} Email address.
 * @returns {boolean}
 */
export function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
